import { render, staticRenderFns } from "./collect-request.vue?vue&type=template&id=5035876a"
import script from "./collect-request.vue?vue&type=script&lang=js"
export * from "./collect-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports